import { combineReducers } from "redux";

import Api from "./Api";
import Artus from "./Artus";
import BertArchive from "./BertArchive";
import BertWarehouse from "./BertWarehouse";
import Configuration from "./Configuration";
import User from "./User";
import ui from "./Ui";

export default combineReducers({
  Api,
  Artus,
  BertArchive,
  BertWarehouse,
  Configuration,
  User,
  ui,
});
